import axios from 'axios';
import orderBy from 'lodash.orderby';
import {
  accessRights
} from "@/service/accessRights";
/************sample usage***************/

/*import ApiService from '@/service/apiService';*/

/*this.apiService = new ApiService();
var accessToken =  this.apiService.getUserAccessToken();
var p = this.apiService.getUserRolesFromAccessToken(accessToken);
p.then(function(roles){
    console.log('getUserRolesFromAccessToken:', roles);
})
var q = this.apiService.getPavementAgeSummary(accessToken);
q.then(function(s){
    console.log('getPavementAgeSummary:', s);
})*/ 

export default class apiService{
    
    constructor(){
        this.api = axios.create({
            baseURL: process.env.__API_URL__,
            timeout: 120000,
            headers: {'X-Custom-Header': 'foobar'}
        })
    }

    ///////////////////
    getAccessRights(username, systemCodes, onGet, onError) {
        var request = this.api.post('/users/info', {
            user_names : [username]
        });
        var result = [];
        request.then(function(reqResult) {
            if (reqResult && reqResult.data && reqResult.data[0]) {
                result = reqResult.data[0];
            } else {
                for (systemCode in SystemCodes) {
                    result[systemCode] = 0;
                }
            }
            if (onGet) {
                onGet(result);
            }
        }).catch( function(error) {
            if (onError) {
                onError(error);
            }
        });
        return request;
    }

    getAccessRight(username, systemCode, onGet, onError) {
        return getAccessRights(username, [systemCode], onGet, onError);
    }


    ///////////////////

    //usage:
    // let service = new apiService();
    // var portalUserId = sessionStorage['portalUserId'];
    // console.log("service", service);
    // service.checkAccessRight(portalUserId, "POT_WELCOME", 3).then((results) => {
    //   console.log("checkAccessRight::results", results);

    // });
    checkAccessRight(portalUserId, accessRightCode, accessLevel,message) {
        var defaultMessage = 'You do not have the access right';
        if (message){
            defaultMessage = message;
        }
        return this.hasAccessRight(portalUserId, accessRightCode, accessLevel).then((hasAccessRight) => {
            if (hasAccessRight){
                return true;
            }else{
                window.alert(message)
                return false;
            }
        });

    }

    hasAccessRight(portalUserId, accessRightCode, accessLevel) {
        return this.getUserSystemLevelsByUserName([portalUserId]).then((results) => {
            if (results.data && results.data[0] && results.data[0].user_system_levels.find((eachSystemLevel) => {
                return ((eachSystemLevel.name == accessRightCode) && eachSystemLevel.level >= accessLevel)
              })) {
                return true;
            } else {
                return false;
            }
        });
    }

    //initAccessControl("Portable",this.accessControl)
    getAccessControl(portalUserId, moduleName, level) {
        var accessControl = {};
        return this.getAllRightsByUserName(portalUserId).then((results) => {
            if (results) {
                var keyCollections = [];
                accessRights.forEach((accessRight) => {
                    if (accessRight.name == moduleName) {
                        accessRight.subsystems.map(subsystemAccessDefinition => {
                            results.forEach(ownedAccessRight => {
                                if (ownedAccessRight.name == subsystemAccessDefinition.key &&
                                    ownedAccessRight.level >= level
                                ) {
                                    accessControl[ownedAccessRight.name] = true
                                }
                            });
                        });
                    }
                })
            }
            return accessControl
        });
    }

    //usually used in layout page to collect all user rights and set the page limitation
    getAllRightsByUserName(portalUserId) {
        return this.getUserSystemLevelsByUserName([portalUserId]).then((results) => {
            if (results.data && results.data[0]) {
                return results.data[0].user_system_levels;
            } else {
                return null;
            }
        });
    }

    getUserSystemLevelsByUserName(userNames){

        return this.api.post('/users/info',{
                user_names : userNames
        })
    }

    // getUserAccessToken(){
    //     console.log('apiService::getUserAccessToken')
    //     return JSON.parse(sessionStorage['esriJSAPIOAuth'])['/'][ process.env.__PORTAL_URL__ ]['token'];
    // }

    getUserRolesFromAccessToken(userAccessToken){
        return this.api.get('/user/info',{
            params:{
                user_access_token: userAccessToken
            }
        })
    }

    // getPavementAgeSummary(userAccessToken){
    //     console.log('apiService::getPavementAgeSummary')
    //     return this.api.get('/pavement_age/summary_stat',{
    //         params:{
    //             user_access_token: userAccessToken
    //         }            
    //     });
    // }

    // AddRoleToUsers(adminAccessToken,userNames,roleName){
    //     console.log('apiService::AddRoleToUsers')
    //     return this.api.post('/user/role',{
    //         admin_access_token: adminAccessToken,
    //         user_names: userNames.join(','),
    //         role_name: roleName
    //     });
    // }

    // RemoveRoleFromUser(adminAccessToken,userNames,roleName){
    //     console.log('apiService::RemoveRoleFromUser')
    //     return this.api.delete('/user/role',{
    //         admin_access_token: adminAccessToken,
    //         user_names: userNames.join(','),
    //         role_name: roleName
    //     });
    // }

    updateUserSystemLevels(adminAccessToken,newUserSystemLevelsObj){

        var transformed_user_system_levels = [];
        
        newUserSystemLevelsObj.user_systems.map((eachUserSystem)=>{

            transformed_user_system_levels.push({
                "name": eachUserSystem,
                "level": newUserSystemLevelsObj['user_system_levels'][eachUserSystem] + ""
            })

        });

        return this.api.post('/user/roles',{
            admin_access_token: adminAccessToken,
            user_name: newUserSystemLevelsObj.user_name,
            user_system_levels: transformed_user_system_levels
        });

    }

    exportMap(layersToBePrint,legendsToBePrint,printOptions){
        
        
        layersToBePrint = orderBy(layersToBePrint, ['order'] ,['asc'])

        var layersToBePrintImageUrls = layersToBePrint.map((eachLayer)=>{
            return {
                image_url: eachLayer.imageUrl,
                type: eachLayer.type
            }
        })
        
        var legendsToBePrintTransformed = legendsToBePrint.flatten().filter((eachLayer)=>{
            return (typeof eachLayer.layerName !== "undefined")
        })

        return this.api.post('/printMap',{
            image_urls: layersToBePrintImageUrls,
            map_layer_legends: legendsToBePrintTransformed,
            print_options: printOptions
        },{
            responseType:'blob'
        });

    }

    obtainLock(guid,userName){
        return this.api.post('/editlock/obtainlock',{
            guid: guid,
            user_name: userName
        });
    }

    releaseLock(guid,userName){
        return this.api.post('/editlock/releaselock',{
            guid: guid,
            user_name: userName
        });
    }

    checkLock(guid){
        return this.api.post('/editlock/checklock',{
            guid: guid
        });
    }
}






// WEBPACK FOOTER //
// ./src/service/apiService.js